import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import en from '../../assets/i18n/en.json';
import es from '../../assets/i18n/es.json';

function asTranslations(mod: unknown): TranslationObject {
  if (mod && typeof mod === 'object' && 'default' in (mod as object)) {
    return (mod as { default: TranslationObject }).default;
  }
  return mod as TranslationObject;
}

const TRANSLATIONS: Record<string, TranslationObject> = {
  en: asTranslations(en),
  es: asTranslations(es),
};

export function createTranslateLoader(): TranslateLoader {
  return {
    getTranslation(lang: string): Observable<TranslationObject> {
      return of(TRANSLATIONS[lang] ?? TRANSLATIONS['es']);
    },
  };
}
